import Icon from "@material-ui/core/Icon";
import IconButton from "@material-ui/core/IconButton";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { translate } from "react-i18next";
import NumberFormat from "react-number-format";
import { connect } from "react-redux";

import { DialogContent, DialogTitle } from "@material-ui/core";
import Dialog from "../dialog";
import { styleSalaryEmployee } from "./style";
import PopupInterface from "../popUpInterface";
class SalaryEmployee extends Component {
  constructor(props) {
    super(props);
    this.state = {
      salaryEmployee: [],
      deleteRow: {},
    };
    this.t = this.props.t;
  }
  async componentDidMount() {
    this.props.onRef(this);
  }
  show = (data) => {
    this.setState({ salaryEmployee: data });
    this.PopupInterface.handleDialogOpen();
  };
  hide = () => {
    this.PopupInterface.handleDialogClose();
  };
  openDialog = (row) => {
    this.setState({ deleteRow: row });
    this.mDialog.handleDialogOpen();
  };
  actionDialog = () => {
    this.mDialog.handleDialogClose();
    let salaryEmployee = Array.from(this.state.salaryEmployee);
    let deleteIndex = -1;
    salaryEmployee.forEach((ele, index) => {
      if (ele.userCode === this.state.deleteRow.userCode) deleteIndex = index;
    });
    if (deleteIndex !== -1) {
      salaryEmployee.splice(deleteIndex, 1);
      let totalSalary = 0;
      salaryEmployee.forEach((employee) => {
        totalSalary += employee.bonusTotal;
        totalSalary += employee.salary;
      });
      this.props.handleUpdateSalary({
        ListEmployeeUpdate: salaryEmployee,
        totalSalary: totalSalary,
      });
    }
  };
  render() {
    const { classes, t } = this.props;
    let { salaryEmployee } = this.state;
    let TotalSalary = 0;
    let TotalBonus = 0;
    salaryEmployee.forEach((employee) => {
      TotalSalary += employee.salary;
      TotalBonus += employee.bonusTotal;
    });
    let currencyCode = this.props.setting.setting
      ? this.props.setting.setting.currencyCode
      : "VND";
    return (
      <PopupInterface
        onRef={(dialog) => (this.PopupInterface = dialog)}
        flagOpen={false}
        handleDialogClose={this.hide}
      >
        {/* <Loading onRef={id => (this.loading = id)}/> */}
        <Dialog
          onRef={(dialog) => (this.mDialog = dialog)}
          disagree={t("service_cost_salary_employee_cancel")}
          agree={t("service_cost_salary_employee_continute")}
          title={t("service_cost_salary_employee_confirm")}
          content={t(
            "service_cost_salary_employee_delete_this_employee_salary"
          )}
          action={this.actionDialog}
        />
        <DialogTitle
          id="scroll-dialog-title"
          disableTypography
          className={classes.DialogTitle}
        >
          <Typography variant="h2" className={classes.title}>
            {t("service_cost_total_employee_salary")}
          </Typography>
        </DialogTitle>
        <DialogContent className={classes.DialogContent}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell
                  align="left"
                  style={{ width: "15%" }}
                  className={classes.customHead}
                >
                  {t("service_cost_salary_employee_employee_name")}
                </TableCell>
                <TableCell
                  align="center"
                  style={{ width: "10%" }}
                  className={classes.customHead}
                >
                  {t("service_cost_salary_employee_working_time")}
                </TableCell>
                <TableCell
                  align="center"
                  style={{ width: "10%" }}
                  className={classes.customHead}
                >
                  {t("service_cost_salary_employee_day_off")}
                </TableCell>
                <TableCell
                  align="center"
                  style={{ width: "25%" }}
                  className={classes.customHead}
                >
                  {t("service_cost_salary_employee_salary")}
                </TableCell>
                <TableCell
                  align="center"
                  style={{ width: "25%" }}
                  className={classes.customHead}
                >
                  {t("service_cost_salary_employee_bonus_salary")}
                </TableCell>
                <TableCell
                  align="center"
                  style={{ width: "10%" }}
                  className={classes.customHead}
                >
                  {t("service_cost_salary_employee_delete")}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {salaryEmployee.map((row, index) => (
                <TableRow key={index}>
                  <TableCell
                    align="left"
                    component="th"
                    scope="row"
                    className={classes.customCell}
                  >
                    {row.name}
                  </TableCell>
                  <TableCell align="center" className={classes.customCell}>
                    {" "}
                    0
                  </TableCell>
                  <TableCell align="center" className={classes.customCell}>
                    {" "}
                    0
                  </TableCell>
                  <TableCell align="center" className={classes.customCell}>
                    {" "}
                    <NumberFormat
                      thousandSeparator={true}
                      displayType={"text"}
                      value={row.salary}
                    />{" "}
                    {currencyCode}
                  </TableCell>
                  <TableCell align="center" className={classes.customCell}>
                    {" "}
                    <NumberFormat
                      thousandSeparator={true}
                      displayType={"text"}
                      value={row.bonusTotal}
                    />{" "}
                    {currencyCode}
                  </TableCell>
                  <TableCell align="center" className={classes.customCell}>
                    <IconButton
                      className={classes.buttonHover + " f-center"}
                      onClick={() => this.openDialog(row)}
                      aria-label="Delete"
                    >
                      <Icon
                        className={classes.iconTrashActive + " fa fa-trash"}
                        color="inherit"
                      />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
              <TableRow>
                <TableCell
                  align="left"
                  component="th"
                  scope="row"
                  className={classes.customLastRow}
                >
                  <Typography variant="h6" className={classes.customHead}>
                    {t("service_cost_total_price")}
                  </Typography>
                </TableCell>
                <TableCell
                  align="center"
                  className={classes.customBody}
                ></TableCell>
                <TableCell
                  align="center"
                  className={classes.customBody}
                ></TableCell>
                <TableCell
                  align="center"
                  component="th"
                  scope="row"
                  className={classes.customLastRow}
                >
                  <Typography variant="h6" className={classes.customHead}>
                    <NumberFormat
                      thousandSeparator={true}
                      displayType={"text"}
                      value={TotalSalary}
                    />{" "}
                    {currencyCode}
                  </Typography>
                </TableCell>
                <TableCell align="center" className={classes.customLastRow}>
                  <Typography variant="h6" className={classes.customHead}>
                    <NumberFormat
                      thousandSeparator={true}
                      displayType={"text"}
                      value={TotalBonus}
                    />{" "}
                    {currencyCode}
                  </Typography>
                </TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </DialogContent>
      </PopupInterface>
    );
  }
}

SalaryEmployee.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapState = (state) => ({
  setting: state.setting,
});

const mapDispatch = (dispatch) => ({});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styleSalaryEmployee, { withTheme: true })(SalaryEmployee)
  )
);
